export class UserModel {
    constructor(UserId, NameKjLs, NameKjFs, ClientType, MailAddress, PhoneNumber, Lang, DisplayInfo, PrevReservePk, VendorId, VendorType, CompanyId, CompanyNm, UserKeyNoSupport, UserKeyNoNm, RegistMethod, AuthenticateMethod) {
        this.UserId = UserId;
        this.NameKjLs = NameKjLs;
        this.NameKjFs = NameKjFs;
        this.ClientType = ClientType;
        this.MailAddress = MailAddress;
        this.PhoneNumber = PhoneNumber;
        this.Lang = Lang;
        this.DisplayInfo = DisplayInfo;
        this.PrevReservePk = PrevReservePk;
        this.VendorId = VendorId;
        this.VendorType = VendorType;
        this.CompanyId = CompanyId;
        this.CompanyNm = CompanyNm;
        this.UserKeyNoSupport = UserKeyNoSupport;
        this.UserKeyNoNm = UserKeyNoNm;
        this.RegistMethod = RegistMethod;
        this.AuthenticateMethod = AuthenticateMethod;
    }
}
